<!-- ══════════ Pestaña VES → USDT / USDT → VES / CLP → USDT / USDT → CLP del modal «Tasas por monto» (cuerpo y pie) ══════════ -->

<!-- ───── Cuerpo con scroll interno ───── -->
<div class="fe__cuerpo">

  <div *ngIf="cargando" class="fe__cargando">
    <mat-spinner diameter="28"></mat-spinner>
    <span>Cargando tramos…</span>
  </div>

  <div *ngIf="!cargando && errorCarga" class="fe__aviso fe__aviso--rojo" role="alert">
    <span>{{ errorCarga }}</span>
    <button type="button" class="fe__btn fe__btn--secundario" (click)="cargar()">Reintentar</button>
  </div>

  <ng-container *ngIf="!cargando && editor && borrador">

    <!-- Tasa manual vigente (con vencimiento): aviso fijo arriba -->
    <div class="tu__manual" *ngIf="textoManual as tm" role="status">
      <mat-icon aria-hidden="true">schedule</mat-icon>
      <span>{{ tm }}</span>
    </div>

    <!-- ───── Tasa base ───── -->
    <section class="tu__base" aria-label="Tasa base">
      <div class="tu__base-fila" [class.tu__base-fila--clp]="esClp">
        <!-- Comisión: solo lectura. Se cambia en su modal de siempre. -->
        <div class="tu__lectura" *ngIf="!esClp">
          <span class="tu__rotulo">Comisión % sobre el costo</span>
          <b>{{ pct(comisionPct) }}</b>
          <button type="button" class="fe__chip-btn" (click)="pedirComision()" *ngIf="!esVenta && !soloLectura"
            [disabled]="!editable"
            matTooltip="Abre el modal de comisión VES→USDT (cierra este editor)">
            Cambiar comisión
          </button>
        </div>
        <!-- CLP: descuento base (DESCUENTO_1 / DESCUENTO_1_SELL), solo lectura. -->
        <div class="tu__lectura" *ngIf="esClp">
          <span class="tu__rotulo">Descuento base ({{ esVenta ? 'DESCUENTO_1_SELL' : 'DESCUENTO_1' }})</span>
          <b>{{ n(descuento) }}</b>
          <span class="tu__unidad">CLP por USDT · solo lectura</span>
        </div>
        <div class="tu__campo" *ngIf="!soloLectura; else margenMinTexto">
          <label for="tu-margen-min" class="tu__rotulo">Margen mínimo % (candado)</label>
          <input id="tu-margen-min" type="number" min="0" [max]="50" step="0.01" class="fe__input"
            [class.is-error]="!!errorMargenMin"
            [ngModel]="borrador.margenMinPct" (ngModelChange)="cambiarMargenMin($event)"
            [disabled]="!editable" [attr.aria-invalid]="!!errorMargenMin" />
          <p class="fe__error-campo" *ngIf="errorMargenMin">{{ errorMargenMin }}</p>
        </div>
        <ng-template #margenMinTexto>
          <div class="tu__lectura">
            <span class="tu__rotulo">Margen mínimo % (candado)</span>
            <b>{{ pct(borrador.margenMinPct) }}</b>
          </div>
        </ng-template>

        <!-- CLP: tope % (cuánto puede mejorar el mejor tramo frente a la base) -->
        <ng-container *ngIf="esClp">
          <div class="tu__campo" *ngIf="!soloLectura; else topeTexto">
            <label for="tu-tope" class="tu__rotulo">Tope % {{ esVenta ? 'sobre' : 'bajo' }} la base</label>
            <input id="tu-tope" type="number" min="0" [max]="topeMax" step="0.01" class="fe__input"
              [class.is-error]="!!errorTope"
              [ngModel]="tope" (ngModelChange)="cambiarTope($event)"
              [disabled]="!editable" [attr.aria-invalid]="!!errorTope" />
            <p class="fe__error-campo" *ngIf="errorTope">{{ errorTope }}</p>
          </div>
          <ng-template #topeTexto>
            <div class="tu__lectura">
              <span class="tu__rotulo">Tope % {{ esVenta ? 'sobre' : 'bajo' }} la base</span>
              <b>{{ pct(tope) }}</b>
            </div>
          </ng-template>
        </ng-container>

        <div class="tu__lectura">
          <span class="tu__rotulo">{{ esClp ? 'Spot USD/CLP' : (esDistancia ? 'Tasa Negociación (promedio P2P)' : 'Costo de mercado') }}</span>
          <b>{{ n(referencia) }}</b>
          <span class="tu__unidad">{{ esClp ? 'PRECIO_SPOT, ' : '' }}{{ moneda }} por USDT</span>
        </div>
        <div class="tu__lectura tu__lectura--fuerte">
          <span class="tu__rotulo">Tasa base (tramo A)</span>
          <b>{{ n(base) }}</b>
          <span class="tu__unidad">
            {{ margenBase != null ? ('ganancia ' + pct(margenBase)) : (moneda + ' por USDT') }}
          </span>
        </div>
        <!-- Modelo de distancia (Oscar): las dos puntas, el ajuste de la fila activa y el colchón -->
        <div class="tu__lectura tu__lectura--verde" *ngIf="vistaDistancia as vd">
          <span class="tu__rotulo">{{ vd.rotulos.peor }} &rarr; {{ vd.rotulos.mejor }}</span>
          <b>{{ n(vd.peor) }} &rarr; {{ n(vd.mejor) }}</b>
          <span class="tu__unidad">ajuste {{ pct(vd.ajustePct) }}<ng-container *ngIf="filaDistanciaTexto"> &middot; fila {{ filaDistanciaTexto }}</ng-container> &middot; colch&oacute;n {{ pct(vd.colchonPct) }}</span>
        </div>
        <div class="tu__lectura tu__lectura--verde" *ngIf="!esVenta && !esDistancia">
          <span class="tu__rotulo">Espacio para descontar</span>
          <b>{{ pct(espacio) }}</b>
          <span class="tu__unidad">{{ piso != null ? ('ningún tramo baja de ' + n(piso)) : '' }}</span>
        </div>
        <div class="tu__lectura tu__lectura--verde" *ngIf="esVenta && !esDistancia">
          <span class="tu__rotulo">Espacio para mejorar</span>
          <b>{{ pct(espacio) }}</b>
          <span class="tu__unidad">{{ techo != null ? ('techo: ningún tramo pasa de ' + n(techo)) : '' }}</span>
        </div>
        <!-- USDT → CLP: la compra final más baja, que pone el techo (÷ 1,005) -->
        <div class="tu__lectura" *ngIf="par === 'USDT-CLP'">
          <span class="tu__rotulo">Compra final más baja</span>
          <b>{{ n(compraMinFinal) }}</b>
          <span class="tu__unidad">CLP por USDT · el techo no pasa de ella ÷ 1,005</span>
        </div>
      </div>

      <div class="tu__info" role="note" *ngIf="vistaDistancia as vd">
        <mat-icon aria-hidden="true">table_rows</mat-icon>
        <span>Modelo de distancia: el primer tramo cobra la tasa publicada ({{ vd.rotulos.peor }}) y el &uacute;ltimo llega al {{ vd.rotulos.mejor }}; Autom&aacute;tico reparte el ajuste de la tabla de distancia parejo entre los tramos y Manual % es la mejora % sobre la tasa publicada. La columna de margen es lo que le queda a la casa sobre la referencia. Con este modelo el margen m&iacute;nimo no mueve las tasas.<ng-container *ngIf="vd.precioCorte != null"> El monto se pasa a USDT con {{ n(vd.precioCorte) }}.</ng-container></span>
      </div>

      <div class="tu__info" role="note">
        <mat-icon aria-hidden="true">info</mat-icon>
        <span *ngIf="!esVenta && !esClp">La comisión se cambia en su modal de siempre y mueve la tasa base, que también usan Vita VES→COP y VES→PEN. Los tramos y el margen mínimo solo afectan a VES→USDT y nunca cambian la tasa base.</span>
        <span *ngIf="esVenta && !esClp">La comisión es de solo lectura aquí: se cambia en «Configurar Comisión USDT/VES» del panel. Los tramos y el margen mínimo solo afectan a USDT→VES y nunca cambian la tasa base. El techo también cuida que vender USDT y volver a comprarlo no deje ganancia.</span>
        <span *ngIf="par === 'CLP-USDT'">El descuento base es de solo lectura aquí y mueve la tasa base, que también usan Vita, ZELLE y la calculadora pública. El margen mínimo y el tope se miden contra el spot USD/CLP y la base; el piso tampoco baja de la venta + 0,5 %, así comprar USDT y venderlo de vuelta no deja ganancia. Los tramos solo afectan a CLP→USDT y nunca cambian la tasa base.</span>
        <span *ngIf="par === 'USDT-CLP'">El descuento base es de solo lectura aquí y mueve la tasa base. El margen mínimo y el tope se miden contra el spot USD/CLP y la base; el techo tampoco pasa de la compra final más baja ÷ 1,005, así vender USDT y volver a comprarlo no deja ganancia. Los tramos solo afectan a USDT→CLP y nunca cambian la tasa base.</span>
      </div>

      <!-- CLP → USDT: lo que se cobra es el snapshot de la fila base vigente -->
      <div class="tu__info" role="note" *ngIf="par === 'CLP-USDT'">
        <mat-icon aria-hidden="true">schedule</mat-icon>
        <span>Los cambios rigen desde la próxima tasa base (unos 2 a 4 minutos).<ng-container *ngIf="publicados != null"> Hoy {{ publicados === 1 ? 'se cobra 1 tramo' : 'se cobran ' + publicados + ' tramos' }}.</ng-container></span>
      </div>

      <div class="fe__aviso fe__aviso--ambar" *ngIf="textoSinTramos" role="status">
        <mat-icon aria-hidden="true">warning</mat-icon>
        <span>{{ textoSinTramos }}</span>
      </div>

      <div class="fe__aviso fe__aviso--ambar" *ngIf="avisoManual && !textoManual" role="status">
        <mat-icon aria-hidden="true">warning</mat-icon>
        <span>{{ avisoManual }}</span>
      </div>
    </section>

    <!-- ───── Simulador: junto a la tabla, en una frase ───── -->
    <section class="fe__tarjeta fe__tarjeta--verde tu__sim" aria-label="Simulador">
      <div class="tu__sim-entrada">
        <label for="tu-simular" class="fe__tarjeta-titulo">Simulador</label>
        <div class="fe__sim-entrada">
          <input id="tu-simular" type="number" min="1" [step]="esVenta ? 100 : 10000" class="fe__input fe__input--ancho"
            [(ngModel)]="simMonto" aria-describedby="tu-simular-resultado" [placeholder]="esVenta ? 'Monto en USDT' : 'Monto en ' + moneda" />
          <span class="fe__moneda">{{ esVenta ? 'USDT' : moneda }}</span>
        </div>
      </div>
      <div id="tu-simular-resultado" class="tu__sim-frase" aria-live="polite">
        <ng-container *ngIf="simulacion as sim">
          <ng-container *ngIf="sim.indice >= 0">
            <p class="tu__frase">
              Si un cliente {{ esVenta ? 'vende' : 'paga' }} <b>{{ n(simMonto, esVenta ? 2 : 0) }} {{ esVenta ? 'USDT' : moneda }}</b>,
              recibe <b class="tu__frase-monto">{{ simRecibe != null ? n(simRecibe) + (esVenta ? ' ' + moneda : ' USDT') : '—' }}</b>
              · tramo <b>{{ filas[sim.indice].letra }}</b>
              <ng-container *ngIf="fila(sim.indice).margenPct != null"> · ganamos ≈ {{ pct(fila(sim.indice).margenPct) }}</ng-container>
            </p>
            <p class="fe__sim-detalle">
              {{ etiquetaRango(sim.indice) }} · tasa {{ n(simTasa?.tasa) }}
              <span class="fe__badge" [class.fe__badge--verde-solido]="simTasa?.oficial" [class.fe__badge--ambar]="!simTasa?.oficial">
                {{ simTasa?.oficial ? 'oficial' : 'estimada' }}
              </span>
              <ng-container *ngIf="!esVenta"> · ≈ {{ n(sim.usdtBase) }} USDT a la tasa base</ng-container>
              <ng-container *ngIf="simMejora as m"> · mejora vs base {{ m.usdt > 0 ? '+' : '' }}{{ n(m.usdt) }} {{ esVenta ? moneda : 'USDT' }} ({{ pct(m.pct, true, true) }})</ng-container>
            </p>
          </ng-container>
          <div class="fe__aviso fe__aviso--rojo" *ngIf="sim.indice < 0" role="alert">{{ mensajeSimulacion(sim.mensaje) }}</div>
        </ng-container>
      </div>
    </section>

    <!-- Barra visual (escala logarítmica, en USDT). Con muchos tramos o en el celular, fichas. -->
    <div class="fe__barra tu__barra" *ngIf="segmentos.length && !muchosTramos" role="img"
      [attr.aria-label]="segmentos.length + ' tramos en USDT'">
      <div class="fe__segmento" *ngFor="let s of segmentos; let i = index; trackBy: trackIndice"
        [style.width.%]="s.ancho"
        [class.is-par]="i % 2 === 1"
        [class.is-simulada]="filaSimulada === i"
        [matTooltip]="s.letra + ': ' + etiquetaRango(i)">
        <span class="fe__segmento-letra">{{ s.letra }}</span>
        <span class="fe__segmento-rango">{{ n(s.desde, 0) }} – {{ n(s.hasta, 0) }} USDT</span>
        <span class="fe__segmento-tasa">{{ n(fila(i).tasa) }}</span>
      </div>
    </div>
    <ul class="tu__fichas" *ngIf="segmentos.length" [class.tu__fichas--siempre]="muchosTramos"
      [attr.aria-label]="'Tramos (desde, en USDT): ' + segmentos.length">
      <li class="tu__ficha" *ngFor="let s of segmentos; let i = index; trackBy: trackIndice"
        [class.is-simulada]="filaSimulada === i">
        <b>{{ s.letra }}</b> {{ n(desde(i), 0) }}+ · {{ n(fila(i).tasa) }}
      </li>
    </ul>

    <div class="fe__grid">

      <!-- ───── Izquierda: tabla ───── -->
      <section class="fe__zona-tabla" aria-label="Tramos">
        <table class="fe__tabla">
          <thead>
            <tr>
              <th scope="col">Tramo</th>
              <th scope="col">Desde – Hasta (USDT)</th>
              <th scope="col">Modo</th>
              <th scope="col" class="is-num">{{ esDistancia ? 'Margen s/ referencia %' : 'Ganancia %' }}</th>
              <th scope="col" class="is-num">Tasa</th>
              <th scope="col" class="is-num">Mejora vs base</th>
              <th scope="col">{{ esVenta ? 'Recibe' : 'Paga' }} por {{ n(usdtEjemplo, 0) }} USDT</th>
              <th scope="col" *ngIf="!soloLectura"><span class="tu__oculto">Apagar</span></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let f of filas; let i = index; trackBy: trackFila"
              [class.is-simulada]="filaSimulada === i"
              [attr.aria-current]="filaSimulada === i ? 'true' : null">

              <!-- Tramo -->
              <td class="fe__celda-franja">
                <span class="fe__letra">{{ f.letra }}</span>
                <span class="fe__badge fe__badge--azul" *ngIf="!f.clave">nuevo</span>
              </td>

              <!-- Desde – Hasta -->
              <td>
                <ng-container *ngIf="!soloLectura; else rangoTexto">
                  <div class="fe__rango">
                    <ng-container *ngIf="i === 0; else desdeFijo">
                      <input type="number" min="1" step="1" class="fe__input"
                        [class.is-error]="!!errorDesde(i)"
                        [ngModel]="borrador.minimo" (ngModelChange)="cambiarDesde(i, $event)"
                        [disabled]="!editable"
                        [attr.aria-label]="'Desde del tramo ' + f.letra + ' (monto mínimo)'"
                        [attr.aria-invalid]="!!errorDesde(i)" />
                    </ng-container>
                    <ng-template #desdeFijo>
                      <span class="fe__fijo" matTooltip="Se ajusta solo con el Hasta anterior">
                        <mat-icon class="fe__candado" aria-hidden="true">lock</mat-icon>
                        {{ n(desde(i), 0) }}
                      </span>
                    </ng-template>
                    <span class="fe__rango-sep" aria-hidden="true">–</span>
                    <input type="number" min="1" step="1" class="fe__input"
                      [class.is-error]="!!errorHasta(i)"
                      [ngModel]="f.hasta" (ngModelChange)="cambiarHasta(i, $event)"
                      [disabled]="!editable"
                      [attr.aria-label]="'Hasta del tramo ' + f.letra"
                      [attr.aria-invalid]="!!errorHasta(i)" />
                  </div>
                  <span class="fe__badge fe__badge--verde" *ngIf="i === 0">mín.</span>
                  <span class="fe__badge fe__badge--verde" *ngIf="i === filas.length - 1">máx.</span>
                  <p class="fe__error-campo" *ngIf="errorDesde(i)">{{ errorDesde(i) }}</p>
                  <p class="fe__error-campo" *ngIf="errorHasta(i)">{{ errorHasta(i) }}</p>
                </ng-container>
                <ng-template #rangoTexto>
                  <span class="fe__texto-num">{{ n(desde(i), 0) }} – {{ n(f.hasta, 0) }}</span>
                </ng-template>
              </td>

              <!-- Modo -->
              <td>
                <select class="fe__input tu__select" [ngModel]="f.modo" (ngModelChange)="cambiarModo(i, $event)"
                  *ngIf="!soloLectura; else modoLectura"
                  [disabled]="!editable" [attr.aria-label]="'Modo del tramo ' + f.letra">
                  <option value="AUTO">Automático</option>
                  <option value="PCT">Manual %</option>
                </select>
                <ng-template #modoLectura><span>{{ modoTexto(f) }}</span></ng-template>
              </td>

              <!-- Ganancia % -->
              <td class="is-num">
                <ng-container *ngIf="f.modo === 'PCT' && !soloLectura; else margenAuto">
                  <input type="number" min="0" [max]="ajusteMax" step="0.01" class="fe__input fe__input--corto tu__input-pct"
                    [class.is-error]="!!errorAjuste(f)"
                    [ngModel]="f.ajuste" (ngModelChange)="cambiarAjuste(i, $event)"
                    [disabled]="!editable"
                    [attr.aria-label]="(esDistancia ? 'Mejora manual % sobre la tasa publicada del tramo ' : 'Ganancia manual % del tramo ') + f.letra"
                    [attr.aria-invalid]="!!errorAjuste(f)" />
                  <p class="fe__error-campo" *ngIf="errorAjuste(f)">{{ errorAjuste(f) }}</p>
                </ng-container>
                <ng-template #margenAuto>
                  <span class="fe__fijo tu__fijo-num">{{ pct(fila(i).margenPct) }}</span>
                </ng-template>
                <span class="fe__subtexto is-ambar" *ngIf="fila(i).recortado && esDistancia">Recortado por la referencia o el tramo anterior</span>
                <span class="fe__subtexto is-ambar" *ngIf="fila(i).recortado && !esDistancia && limite != null && borrador.margenMinPct != null">
                  {{ esVenta ? 'Recortado por la base, el techo o el tramo anterior' : 'Recortado por la base, el piso o el tramo anterior' }}
                </span>
              </td>

              <!-- Tasa -->
              <td class="is-num">
                <span class="fe__tasa" [matTooltip]="fila(i).oficial ? 'Tasa oficial del servidor' : 'Estimada en tu navegador'">
                  {{ n(fila(i).tasa) }}
                  <mat-icon *ngIf="!fila(i).oficial" class="fe__estimada"
                    aria-label="Estimada en tu navegador">schedule</mat-icon>
                </span>
                <span class="fe__subtexto">{{ moneda }} por USDT</span>
              </td>

              <!-- Mejora vs base -->
              <td class="is-num">
                <span class="fe__texto-num">{{ pct(fila(i).mejoraPct, true, true) }}</span>
              </td>

              <!-- Paga por 1.000 USDT -->
              <td>
                <div class="fe__pastilla" *ngIf="pagaPorEjemplo(i) != null">
                  <span class="fe__pastilla-monto">{{ n(pagaPorEjemplo(i), 0) }} {{ moneda }}</span>
                  <span class="fe__pastilla-por">por {{ n(usdtEjemplo, 0) }} USDT</span>
                </div>
                <span *ngIf="pagaPorEjemplo(i) == null">—</span>
              </td>

              <!-- Apagar -->
              <td *ngIf="!soloLectura">
                <button type="button" class="fe__icono-btn fe__quitar" (click)="quitar(i)"
                  [disabled]="!editable || filas.length <= 1"
                  [attr.aria-label]="'Apagar el tramo ' + f.letra"
                  [matTooltip]="filas.length <= 1 ? 'Tiene que quedar al menos un tramo' : 'Apagar tramo (se apaga; su rango lo toma el vecino)'">
                  <mat-icon aria-hidden="true">remove_circle_outline</mat-icon>
                </button>
              </td>
            </tr>

            <!-- Última fila: agregar -->
            <tr class="fe__fila-agregar" *ngIf="!soloLectura">
              <td colspan="8">
                <button type="button" class="fe__btn fe__btn--fantasma" (click)="agregar()"
                  [disabled]="!editable || !puedeAgregar"
                  [matTooltip]="puedeAgregar ? 'El último tramo se corta a la mitad y el nuevo llega hasta su Hasta' : 'Máximo ' + maxActivos + ' tramos activos'">
                  <mat-icon aria-hidden="true">add</mat-icon>
                  Agregar tramo al final
                </button>
                <button type="button" class="fe__btn fe__btn--secundario" (click)="automaticos()"
                  [disabled]="!editable || !filas.length || todosAuto"
                  matTooltip="Vuelve a poner todos los tramos en Automático">
                  Todos automáticos
                </button>
                <button type="button" class="fe__btn fe__btn--secundario" *ngIf="hayCambios" (click)="descartar()" [disabled]="guardando">
                  Descartar cambios
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <p class="fe__nota" *ngIf="!soloLectura && !puedeAgregar && filas.length">
          Llegaste al máximo de {{ maxActivos }} tramos activos: quita uno para agregar otro (los apagados no cuentan).
        </p>
        <div *ngIf="errorAccion" class="fe__aviso fe__aviso--rojo" role="alert">{{ errorAccion }}</div>

        <p class="fe__nota tu__nota-bloque" *ngIf="!esVenta">
          Con un solo tramo todos pagan la tasa base, como hoy. Automático reparte el espacio parejo: el primero cobra la base y el último queda en el mínimo. A mayor monto, igual o menor tasa: un tramo nunca cobra más que el anterior.
        </p>
        <p class="fe__nota tu__nota-bloque" *ngIf="esVenta">
          Con un solo tramo todos reciben la tasa base, como hoy. Automático reparte el espacio parejo: el primero paga la base y el último queda en el techo. A mayor monto, igual o mayor tasa: un tramo nunca paga menos que el anterior.
        </p>
        <p class="fe__nota">
          <mat-icon class="fe__estimada" aria-hidden="true">schedule</mat-icon>
          = estimada en tu navegador. Sin ícono = tasa oficial del servidor, que es la que vale.
        </p>
      </section>

      <!-- ───── Derecha: panel ───── -->
      <aside class="fe__panel" aria-label="Cambios y guardado">

        <!-- Cambios -->
        <section class="fe__tarjeta" *ngIf="!soloLectura">
          <h3 class="fe__tarjeta-titulo">Cambios</h3>
          <p class="fe__vacio" *ngIf="!cambiosLista.length">Sin cambios.</p>
          <ul class="fe__lista" *ngIf="cambiosLista.length">
            <li *ngFor="let c of cambiosLista">{{ c }}</li>
          </ul>
        </section>

        <!-- Vista previa oficial -->
        <section class="fe__tarjeta" aria-live="polite">
          <div class="fe__estado-fila">
            <h3 class="fe__tarjeta-titulo">Vista previa</h3>
            <button type="button" class="fe__chip-btn" (click)="previsualizar()"
              [disabled]="previsualizando || guardando || !!erroresLocales.length"
              matTooltip="Vuelve a pedir la tasa oficial ahora">
              Actualizar
            </button>
          </div>
          <p class="fe__estado fe__estado--azul" *ngIf="previsualizando">
            <mat-spinner diameter="14"></mat-spinner> Calculando…
          </p>
          <p class="fe__estado" *ngIf="!previsualizando && vista && vistaVieja">Esperando a que termines de escribir…</p>
          <p class="fe__estado fe__estado--verde" *ngIf="!previsualizando && vista && !vistaVieja && vista.ok">
            <mat-icon aria-hidden="true">check_circle</mat-icon> Tasas oficiales al día
          </p>
          <ul class="fe__lista fe__lista--rojo" *ngIf="errores.length" role="alert">
            <li *ngFor="let e of errores">{{ e }}</li>
          </ul>
          <ul class="fe__lista fe__lista--ambar" *ngIf="advertencias.length">
            <li *ngFor="let a of advertencias">{{ a }}</li>
          </ul>
        </section>

        <!-- Motivo -->
        <section class="fe__tarjeta" *ngIf="!soloLectura">
          <label for="tu-motivo" class="fe__tarjeta-titulo">Motivo <span class="fe__obligatorio">(obligatorio)</span></label>
          <textarea id="tu-motivo" rows="2" class="fe__input fe__input--area" [(ngModel)]="motivo"
            [maxlength]="motivoMax" [disabled]="!editable"
            [class.is-error]="!!motivo && !motivoValido"
            placeholder="Por ejemplo: agrego un tramo desde 1.000 USDT"></textarea>
          <p class="fe__error-campo" *ngIf="motivo && !motivoValido">Escribe entre 5 y 255 caracteres.</p>
        </section>

        <div class="fe__aviso fe__aviso--verde" *ngIf="mensaje" role="status">{{ mensaje }}</div>
      </aside>
    </div>
  </ng-container>
</div>

<!-- ───── Pie fijo ───── -->
<footer class="fe__pie">
  <div class="fe__historial" *ngIf="historialAbierto" id="tu-historial">
    <p class="fe__vacio" *ngIf="!historialItems.length && !cargandoHistorial">Sin cambios registrados.</p>
    <div class="fe__tabla-caja" *ngIf="historialItems.length">
      <table class="fe__tabla fe__tabla--historial" [class.is-cargando]="cargandoHistorial">
        <thead>
          <tr>
            <th scope="col">Fecha</th>
            <th scope="col">Qué</th>
            <th scope="col">Acción</th>
            <th scope="col">Cambio</th>
            <th scope="col">Quién</th>
            <th scope="col">Motivo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let h of historialItems">
            <td class="is-nowrap">{{ h.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
            <td class="is-mono">{{ etiquetaClave(h.clave) }}</td>
            <td><b>{{ h.accion }}</b></td>
            <td>{{ resumenCambio(h) || '—' }}</td>
            <td>{{ h.editadoPor || '—' }}</td>
            <td>{{ h.motivo || '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="fe__error-campo" *ngIf="errorHistorial" role="alert">{{ errorHistorial }}</p>
    <div class="fe__paginacion" *ngIf="hayPaginacion">
      <button type="button" class="fe__btn fe__btn--secundario" (click)="irAPagina(historialPagina - 1)"
        [disabled]="historialPagina <= 1 || cargandoHistorial">‹ Anteriores</button>
      <span aria-live="polite">{{ cargandoHistorial ? 'Cargando…' : 'Página ' + historialPagina + ' de ' + paginasHistorial }}</span>
      <button type="button" class="fe__btn fe__btn--secundario" (click)="irAPagina(historialPagina + 1)"
        [disabled]="historialPagina >= paginasHistorial || cargandoHistorial">Siguientes ›</button>
    </div>
  </div>

  <div class="fe__pie-fila">
    <button type="button" class="fe__btn fe__btn--texto" (click)="toggleHistorial()"
      [attr.aria-expanded]="historialAbierto" aria-controls="tu-historial" [disabled]="!editor">
      Historial ({{ historialTotal }})
      <mat-icon aria-hidden="true">{{ historialAbierto ? 'expand_more' : 'chevron_right' }}</mat-icon>
    </button>

    <div class="fe__pie-acciones">
      <span class="fe__pie-motivo fe__pie-motivo--candado" *ngIf="soloLectura">
        <mat-icon aria-hidden="true">lock</mat-icon>{{ textoSoloLectura }}
      </span>
      <span class="fe__pie-motivo" *ngIf="!soloLectura && !puedeGuardar && !guardando && editor">{{ motivoNoGuardar }}</span>
      <button type="button" class="fe__btn fe__btn--secundario" (click)="cerrarPedido.emit()" [disabled]="guardando">
        {{ soloLectura ? 'Cerrar' : 'Cancelar' }}
      </button>
      <button type="button" class="fe__btn fe__btn--primario" (click)="guardar()" [disabled]="!puedeGuardar" *ngIf="!soloLectura"
        [matTooltip]="motivoNoGuardar" [matTooltipDisabled]="puedeGuardar || guardando">
        <mat-spinner *ngIf="guardando" diameter="16" class="fe__spinner-blanco"></mat-spinner>
        {{ guardando ? 'Guardando…' : 'Guardar tramos' }}
      </button>
    </div>
  </div>
</footer>

<!-- Bloqueo mientras guarda -->
<div class="fe__bloqueo" *ngIf="guardando" role="status" aria-live="assertive">
  <mat-spinner diameter="40"></mat-spinner>
  <span>Guardando…</span>
</div>
